// Path mappings for URL to page name conversion
// Single source of truth for all path mappings used by both server and client

export const PATH_MAPPINGS: { [key: string]: string } = {
  '/users/forgot': 'forgot',
  '/_sisu/do/step2': 'step2',
  '/users/login': 'login',
  '/users/logout/oauth2': 'logout-oauth2',
  '/_sisu/do/tfa_reminder': 'tfa-reminder',
  '/join/intent': 'intent',
  '/join/content-filter': 'content-filter',
  '/join/topics': 'topics',
  '/users/reset-password/:username/:passkey': 'reset-password',
  '/settings/applications': 'applications',
  '/join/oauth2': 'oauth2',
  '/join': 'join',
  '/_sisu/modals/closemodal': 'closemodal',
  '/_sisu/do/signin': 'signin',
  '/_sisu/do/signin_tfa': 'signin-tfa',
  '/_sisu/do/forgot': 'forgot-post',
  '/_sisu/do/signup': 'signup',
  '/_sisu/do/signup2': 'signup2',
  '/_sisu/do/reset_password': 'reset-password-post',
  '/users/join-login': 'join',
  '/_sisu/discord/done': 'discord-done',
  '/_sisu/_cookies': 'cookies',
};
